export type Bonus = {
  number: string
  title: string
  body: string
  /** Optional cover image. Empty = the CSS cover in the product palette. */
  cover?: string
  /** Tailwind bg class for the CSS cover's accent band. */
  accent: string
}

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'Quick-Start: Your First Stacked Week',
    body: '300 pages and 50 students? Start here. A day-by-day route for your first week: which page to open each day, what to say the first time your group sees a grid, and the most common tweaks after week one.',
    cover: 'https://cdn.magicpatterns.com/uploads/tERpcYNrC3Kz2tZy4crEtL/-bonus-1-mockup-quick-start.png',
    accent: 'bg-sage',
  },
  {
    number: '02',
    title: 'Master Goal and Sound Finder',
    body: "Look up a student's goal or target sound and see at a glance which theme, volume and grid cell to use — across all six volumes. Indexed by sound group, language focus, social skill and activity type.",
    cover: 'https://cdn.magicpatterns.com/uploads/vtinkRkCDFF6Rdq6dB1A7a/-bonus-2-mockup-goal-and-sound-finder.png',
    accent: 'bg-smoke',
  },
  {
    number: '03',
    title: 'Any-Theme Game Boards',
    body: '12 print-once, black-and-white game boards that work with any grid in the pack. Every student practices their own row on every turn while the whole group plays the same game — with 2, 4 or 6 players.',
    cover: 'https://cdn.magicpatterns.com/uploads/e6RJSULbktzXS4HLjZ1K7S/-bonus-3.png',
    accent: 'bg-gold',
  },
  {
    number: '04',
    title: 'Sound Cue Cards',
    body: 'One card per sound group that sits in front of the student, with the cue you chose for them. They self-check with their card while you keep the rest of the group moving.',
    cover: 'https://cdn.magicpatterns.com/uploads/sqnTA4gi5NEdtdSWYbgbui/-bonus-4.png',
    accent: 'bg-coral',
  },
  {
    number: '05',
    title: 'Fluency and AAC Joining Guide',
    body: 'How a student working on fluency, or communicating with AAC, joins the same stacked session — row by row. Includes a core-word list and 8 fringe words for each of the 36 themes.',
    cover: 'https://cdn.magicpatterns.com/uploads/h8WG6SZHxbry5kfrdoGEjy/-bonus-5.png',
    accent: 'bg-plum-mid',
  },
]
